import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-visa-response-success',
  templateUrl: './payment-visa-response-success.component.html',
  styleUrls: ['./payment-visa-response-success.component.scss'],
})
export class PaymentVisaResponseSuccessComponent {
  @Input() transactionId: string;
  @Input() dataResponse: Partial<NiubizAuthorizationResponse>;
}
